import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(() => ({
    btn: {
        display: 'inline-block',
        padding: '5px 12px',
        fontSize: '14px',
        color: '#00a3f9',
        background: 'none',
        border: '1px solid #00a3f9',
        borderRadius: 12,
        marginBottom: 12,
        cursor: 'pointer',
        '&:hover': {
            borderColor: 'rgba(255,255,255,.15)',
            color: '#ffce01'
        },
        outline: 'none'
    }
}))

const getRows = (provider) => {
    return provider.map((item, key) => {
        const result =  +item.sum.toFixed(2) - +item.sum_win.toFixed(2)
        return {
            id: key + 1,
            provider: item.provider,
            count:new Intl.NumberFormat('ru-RU').format(item.count),
            sum: new Intl.NumberFormat('ru-RU').format(item.sum.toFixed(2)) + '₽',
            sum_win: new Intl.NumberFormat('ru-RU').format(item.sum_win.toFixed(2)) + '₽',
            rtp: (item.sum_win / item.sum * 100).toFixed(0) + '%',
            difference: new Intl.NumberFormat('ru-RU').format(result.toFixed(2)) + '₽'
        }
    })
} 

const columns = [
    { id: 'id', label: 'ID'},
    { id: 'provider', label: 'Провайдер'},
    { id: 'count', label: 'Количество ставок'},
    { id: 'sum', label: 'Сумма ставок'},
    { id: 'sum_win', label: 'Сумма выигрышей'},
    { id: 'rtp', label: 'Среднее RTP (%)'},
    { id: 'difference', label: 'Разница'},
  ];

export {
    getRows,
    useStyles,
    columns
}